export const ConsentCookieName = 'cookie_consent'
export const BannerTypeCookieName = 'bt'

export enum CookieKeys {
  Analytical = 'analyticsConsentGranted',
  Targeting = 'adConsentGranted',
}

export interface ConsentCookie {
  [CookieKeys.Analytical]: boolean
  [CookieKeys.Targeting]: boolean
}

export const defaultCookies = {
  [CookieKeys.Analytical]: false,
  [CookieKeys.Targeting]: false,
}

export const bannerDescription =
  'This site uses cookies and related technologies for site operation, and analytics as described in our'
export const bannerDescLinkText = 'Privacy Policy'
export const bannerDescriptionCont =
  '. You may choose to consent to our use of these technologies, reject non-essential technologies, or further manage your preferences.'
export const acceptAllText = 'Accept All'
export const requiredCookiesDesc =
  'These cookies are necessary for the correct functioning of the website and cannot be switched off by our systems. These cookies are generally only set in response to actions undertaken by you which correspond to service requests, such as defining your data protection settings, registering or filling in forms. You can change your browser settings to deactivate these cookies, but this can impede access and use of the website. These cookies do not store personal data.'
export const analyticalCookiesDesc =
  'These cookies enable us to count visits and origins of accesses so that we can evaluate and improve the services on our website. They help us to understand which pages are the most popular, which are the least visited, and how visitors navigate around our site. The information collected is analyzed cumulatively and is therefore anonymous. If you do not allow these cookies, we will not know when you have visited our website.'
export const targetingCookiesDesc =
  'These cookies may be set through our site by our advertising partners. They may be used by those companies to build a profile of your interests and show you relevant adverts on other sites. They do not store directly personal information, but are based on uniquely identifying your browser and internet device. We collaborate with third parties to display advertisements on our Site. If you do not allow these cookies, you will experience less targeted advertising.'

export type CookieBannerQueryResults = {
  contentfulCookieBanner: {
    title: string
  }
}

export const innerAcceptAllButtonAccordion = 'inner-accept-all-accordion'
export const innerAcceptAllButtonNonAccordion = 'inner-accept-all-non-accordion'

export enum CookieBannerTypes {
  NonAccordion = 'non-accordion-cookie-banner',
}
